import React, { useState, useEffect } from 'react';
import { MDBTable, MDBTableHead, MDBTableBody, MDBContainer } from 'mdb-react-ui-kit';
import { Row, Col, Container, Button, } from 'react-bootstrap';
import '../../index.css';
import Navbar from '../../components/common/Navbar';
import apiService from '../../services/api.services';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import * as FileSaver from 'file-saver';
import * as ExcelJS from 'exceljs';
import axios from 'axios';
import * as XLSX from 'xlsx';

const CostSheetEntList = () => {


  const [error, setError] = useState(null);
  const [listLoading, setListLoading] = useState(false);

    useEffect(() => {
        const JWTtoken = window.sessionStorage.getItem('token')
        apiService.getEntCostSheetLists(JWTtoken)
            .then(response => {
                console.log(':::::Array of costSheetENT Log Records:::::')
                setAllRows(response.data);

            })
            .catch(error => {
                setError(error);
            });
    }, []);

    const [allRows, setAllRows] = useState([]);
    const [excelData, setexcelData] = useState([]);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10; // Number of rows per page

    // Calculate total pages
    const totalPages = Math.ceil(allRows.length / rowsPerPage);

    // Calculate the rows to display on the current page
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allRows.slice(indexOfFirstRow, indexOfLastRow);
    
    const pageGroupSize = 5;
    const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
    const startPage = currentGroup * pageGroupSize + 1;
    const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // const exportExcel = () => {
    //     // toast.success('Hitttt hogya');

    //     // Updated header array
    //    const header = [
    //         "Sr No", "CRM No", "Customer Name", "Salesperson Name", "Total Revenue", "Total Cost", "Total Other Cost", "Margin",
    //         "Margin%", "Vendor terms", "Customer terms", "Actual Cost Amount", "Actual Payment Amount",
    //         "Actual Vendor Payment Date", "Actual Revenue Amount", "Actual  Receipt Amount",
    //         "Actual Customer Receipt Date", "Gross Margin %", "Gross Margin Improve/ (Drop)%",
    //         "Cashflow impacted Days", "Finance Exp/(Income)", "Finance %", "Margin Benefit / Impact", "Cashflow Benefit/ Impact",
	//           "Net Benefit/Impact beyond the approval" , "Expert Advice on Deal Analysis"
    //     ];

    //     // Create a new workbook and worksheet
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet('Data');

    //     // Add header row
    //     worksheet.addRow(header);

    //     // Apply styles to the header row (first row)
    //     const headerRow = worksheet.getRow(1);
    //     headerRow.font = { bold: true, color: { argb: 'FFFFFF' } }; // White bold font
    //     headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '808080' } }; // Gray background
    //     headerRow.alignment = { horizontal: 'center', vertical: 'middle' };

    //     // Add data rows (your allRows data)
    //     excelData.forEach(row => {
    //         worksheet.addRow(Object.values(row));
    //     });

    //     // Adjust column widths dynamically based on header length (or content)
    //     header.forEach((column, index) => {
    //         const maxLength = Math.max(column.length, ...excelData.map(row => String(Object.values(row)[index]).length));
    //         worksheet.getColumn(index + 1).width = maxLength + 2; // Add some padding
    //     });

    //     // Apply borders to the entire table (all cells in the worksheet)
    //     const totalRows = worksheet.rowCount;
    //     const totalCols = header.length;

    //     for (let row = 1; row <= totalRows; row++) {
    //         for (let col = 1; col <= totalCols; col++) {
    //             const cell = worksheet.getCell(row, col);
    //             cell.border = {
    //                 top: { style: 'thin', color: { argb: '000000' } },    // Black top border
    //                 left: { style: 'thin', color: { argb: '000000' } },   // Black left border
    //                 bottom: { style: 'thin', color: { argb: '000000' } }, // Black bottom border
    //                 right: { style: 'thin', color: { argb: '000000' } }   // Black right border
    //             };
    //         }
    //     }

    //     // Create a buffer and export the Excel file
    //     workbook.xlsx.writeBuffer().then(buffer => {
    //         const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //         FileSaver.saveAs(data, 'Final costSheetENT.xlsx');  // Use FileSaver to save the file
    //     });
    // };

      const fetchAndExport = async () => {
        setListLoading(true);
        try {
            const host = window.location.hostname;
            const JWTtoken = window.sessionStorage.getItem('token')
            const { data: combinedData } = await axios.get(`https://${host}:9001/api/fetchEntCSListData`, 
                            {
                              headers: {
                                'Content-Type': 'multipart/form-data',
                                'authorization': JWTtoken,
                              },
                            }
                          )
            const rows = Object.entries(combinedData).map(([series, record]) => {
                const b = record.basiclog   || {};
                const a = record.approvals  || {};
                const f = record.financials || {};
                return {
                    // ─── BASIC LOG ───────────────────────────────────
                    'Form Series':                          b.formSeries                        || '',
                    'Form Reopen Count':                    b.formReopenCount                   ?? '',
                    'CRM Number':                           b.crmNumber                         || '',
                    'Customer Name':                        b.customerName                      || '',
                    'Sales Person Name':                    b.salesPersonName                   || '',
                    'Sales Person ID':                      b.salesPersonID                     || '',
                    'User Name':                            b.userName                          || '',
                    'User Role':                            b.userRole                          || '',
                    'PAN':                                  b.pan                               || '',
                    'Opportunity Name':                     b.opportunityName                   || '',
                    'OEM':                                  b.OEM                               || '',
                    'Deal Type':                            b.dealType                          || '',
                    'Hitachi Role In This Deal':            b.HitachiRoleInThisDeal             || '',
                    'Primary Transaction Currency':         b.transactionCurrency               || '',
                    'Secondary Transaction Currency':       b.secondaryTransactionCurrency      || '',
                    'Vendor Payment Terms':                 b.vendorPaymentTerms                || '',
                    'Vendor Billing Cycle':                 b.vendorBillingCycle                || '',
                    'Customer Payment Terms':               b.customerPaymentTerms              || '',
                    'Approval Request Date':                b.approvalRequestDate               || '',
                    'Send For Appv Req Date':               b.sendForAppvReqDate                || '',
                    'Material Delivery Date':               b.materialDeliveryDate              || '',
                    'Expected Date Customer Receipt':       b.ExpectedDateCustomerRecipt        || '',
                    'Expected Date Vendor Payment':         b.ExpectedDateVendorPayment         || '',
                    'Reason For Margin < 6%':               b.ReasonForMarginLessThanSixPercent || '',
                    'Rebate Amount Details':                b.RebateAmountDetails               || '',
                    'Conversion Rate':                      b.ConversionRate                    || '',
                    'Remarks':                              b.remarks                           || '',
                    'Expert Advice Cashflow':               b.expertAdviceCashflow              || '',
                    'Expert Advice Margin':                 b.expertAdviceMargin                || '',
                    'Record Created At':                    b.recordCreatedAt                   || '',
                    'Record Updated At':                    b.recordUpdatedAt                   || '',
                    // Functional Heads
                    'Functional Head 1 ID':                 b.functionalHead1ID                 || '',
                    'Functional Head 1 Name':               b.functionalHead1Name               || '',
                    'Functional Head 2 ID':                 b.functionalHead2ID                 || '',
                    'Functional Head 2 Name':               b.functionalHead2Name               || '',
                    'Functional Head 3 ID':                 b.functionalHead3ID                 || '',
                    'Functional Head 3 Name':               b.functionalHead3Name               || '',
                    'Functional Head 4 ID':                 b.functionalHead4ID                 || '',
                    'Functional Head 4 Name':               b.functionalHead4Name               || '',
                    'Functional Head 5 ID':                 b.functionalHead5ID                 || '',
                    'Functional Head 5 Name':               b.functionalHead5Name               || '',
                    'Functional Head 6 ID':                 b.functionalHead6ID                 || '',
                    'Functional Head 6 Name':               b.functionalHead6Name               || '',
                    // Year-wise Values
                    'Curr Year 1':                          b.currYear1                         ?? '',
                    'Curr Year 2':                          b.currYear2                         ?? '',
                    'Curr Year 3':                          b.currYear3                         ?? '',
                    'Curr Year 4':                          b.currYear4                         ?? '',
                    'Curr Year 5':                          b.currYear5                         ?? '',
                    'Curr Year 6':                          b.currYear6                         ?? '',
                    'Curr Year 7':                          b.currYear7                         ?? '',
                    // Export Compliance Questions
                    'Ex Comp Ques 1':                       b.ExCompQues1                       || '',
                    'Ex Comp Ques 2':                       b.ExCompQues2                       || '',
                    'Ex Comp Ques 3':                       b.ExCompQues3                       || '',
                    'Ex Comp Ques 4':                       b.ExCompQues4                       || '',
                    'Ex Comp Ques 5':                       b.ExCompQues5                       || '',
                    'Ex Comp Ques 6':                       b.ExCompQues6                       || '',
                    'Ex Comp Ques 7':                       b.ExCompQues7                       || '',
                    'Ex Comp Ques 8':                       b.ExCompQues8                       || '',
                    'Ex Comp Ques 9':                       b.ExCompQues9                       || '',
                    'Ex Comp Ques 10':                      b.ExCompQues10                      || '',
                    'Ex Comp Ques 11':                      b.ExCompQues11                      || '',
                    'Ex Comp Ques 12':                      b.ExCompQues12                      || '',
                    'Ex Comp Ques 13':                      b.ExCompQues13                      || '',
                    'Ex Comp Ques 14':                      b.ExCompQues14                      || '',
                    // ─── FINANCIALS (Total Row) ───────────────────────
                    'Currency':                             f.currency                          || '',
                    'Selling Value':                        f.sellingValue                      ?? '',
                    'Transfer Prices':                      f.transferPrices                    ?? '',
                    'Finance Fee':                          f.financeFee                        ?? '',
                    'Contingency Fee':                      f.contingencyFee                    ?? '',
                    'Penalty':                              f.penalty                           ?? '',
                    'Insurance Fee':                        f.insuranceFee                      ?? '',
                    'Forex Fee':                            f.forexFee                          ?? '',
                    'Margin':                               f.margin                            ?? '',
                    'Margin Percentage':                    f.marginPercentage                  ?? '',
                    // ─── APPROVALS ────────────────────────────────────
                    'Overall Approval Status':              a.status                            || '',
                    // Team Leader
                    'TL Req':                               a.appvTeamLeaderReq                 || '',
                    'TL Status':                            a.appvTeamLeaderStatus              || '',
                    'TL Message':                           a.appvTeamLeaderMessage             || '',
                    'TL Date':                              a.appvDateTeamLeader                || '',
                    // Branch Head
                    'BH Req':                               a.appvBranchHeadReq                 || '',
                    'BH Status':                            a.appvBranchHeadStatus              || '',
                    'BH Message':                           a.appvBranchHeadMessage             || '',
                    'BH Date':                              a.appvDateBranchHead                || '',
                    // Region Business Head
                    'RBH Req':                              a.appvRegionBusinessHeadReq         || '',
                    'RBH Status':                           a.appvRegionBusinessHeadStatus      || '',
                    'RBH Message':                          a.appvRegionBusinessHeadMessage     || '',
                    'RBH Date':                             a.appvDateRegionBusinessHead        || '',
                    // Business Finance
                    'BF Req':                               a.appvBusinessFinanceReq            || '',
                    'BF Status':                            a.appvBusinessFinanceStatus         || '',
                    'BF Message':                           a.appvBusinessFinanceMessage        || '',
                    'BF Date':                              a.appvDateBusinessFinance           || '',
                    // Export Compliance
                    'EC Req':                               a.appvExportComplianceReq           || '',
                    'EC Status':                            a.appvExportComplianceStatus        || '',
                    'EC Message':                           a.appvExportComplianceMessage       || '',
                    'EC Date':                              a.appvDateExportCompliance          || '',
                    // Credit Insurance
                    'CI Req':                               a.appvCreditInsuranceReq            || '',
                    'CI Status':                            a.appvCreditInsuranceStatus         || '',
                    'CI Message':                           a.appvCreditInsuranceMessage        || '',
                    'CI Date':                              a.appvDateCreditInsurance           || '',
                    // Legal Head
                    'Legal Head Req':                       a.appvLegalHeadReq                  || '',
                    'Legal Head Status':                    a.appvLegalHeadStatus               || '',
                    'Legal Head Message':                   a.appvLegalHeadMessage              || '',
                    'Legal Head Date':                      a.appvDateLegalHead                 || '',
                    // SVP Director
                    'SVP Director Req':                     a.appvSVPDirectorReq                || '',
                    'SVP Director Status':                  a.appvSVPDirectorStatus             || '',
                    'SVP Director Message':                 a.appvSVPDirectorMessage            || '',
                    'SVP Director Date':                    a.appvDateSVPDirector               || '',
                    // CFO
                    'CFO Req':                              a.appvCFOReq                        || '',
                    'CFO Status':                           a.appvCFOStatus                     || '',
                    'CFO Message':                          a.appvCFOMessage                    || '',
                    'CFO Date':                             a.appvDateCFO                       || '',
                    // CEO
                    'CEO Req':                              a.appvCEOReq                        || '',
                    'CEO Status':                           a.appvCEOStatus                     || '',
                    'CEO Message':                          a.appvCEOMessage                    || '',
                    'CEO Date':                             a.appvDateCEO                       || '',
                    // COO
                    'COO Req':                              a.appvCOOReq                        || '',
                    'COO Status':                           a.appvCOOStatus                     || '',
                    'COO Message':                          a.appvCOOMessage                    || '',
                    'COO Date':                             a.appvDateCOO                       || '',
                    // DYT-CFO
                    'DYT-CFO Req':                          a.appvDytCFOReq                     || '',
                    'DYT-CFO Status':                       a.appvDytCFOStatus                  || '',
                    'DYT-CFO Message':                      a.appvDytCFOMessage                 || '',
                    'DYT-CFO Date':                         a.appvDateDytCFO                    || '',
                    // Functional Heads (Approvals)
                    'FH1 Req':                              a.appvFunctionalHeadReq             || '',
                    'FH1 Status':                           a.appvFunctionalHeadStatus          || '',
                    'FH1 Message':                          a.appvFunctionalHeadMessage         || '',
                    'FH1 Date':                             a.appvDateFunctionalHead            || '',
                    'FH2 Req':                              a.appvFunctionalHead2Req            || '',
                    'FH2 Status':                           a.appvFunctionalHead2Status         || '',
                    'FH2 Message':                          a.appvFunctionalHead2Message        || '',
                    'FH2 Date':                             a.appvDateFunctionalHead2           || '',
                    'FH3 Req':                              a.appvFunctionalHead3Req            || '',
                    'FH3 Status':                           a.appvFunctionalHead3Status         || '',
                    'FH3 Message':                          a.appvFunctionalHead3Message        || '',
                    'FH3 Date':                             a.appvDateFunctionalHead3           || '',
                    'FH4 Req':                              a.appvFunctionalHead4Req            || '',
                    'FH4 Status':                           a.appvFunctionalHead4Status         || '',
                    'FH4 Message':                          a.appvFunctionalHead4Message        || '',
                    'FH4 Date':                             a.appvDateFunctionalHead4           || '',
                    'FH5 Req':                              a.appvFunctionalHead5Req            || '',
                    'FH5 Status':                           a.appvFunctionalHead5Status         || '',
                    'FH5 Message':                          a.appvFunctionalHead5Message        || '',
                    'FH5 Date':                             a.appvDateFunctionalHead5           || '',
                    'FH6 Req':                              a.appvFunctionalHead6Req            || '',
                    'FH6 Status':                           a.appvFunctionalHead6Status         || '',
                    'FH6 Message':                          a.appvFunctionalHead6Message        || '',
                    'FH6 Date':                             a.appvDateFunctionalHead6           || '',
                    // Mgmt Approvals
                    'Mgmt RBH Req':                         a.mgmtAppvRegionBusinessHeadReq     || '',
                    'Mgmt RBH Status':                      a.mgmtAppvRegionBusinessHeadStatus  || '',
                    'Mgmt RBH Message':                     a.mgmtAppvRegionBusinessHeadMessage || '',
                    'Mgmt RBH Date':                        a.mgmtAppvDateRegionBusinessHead    || '',
                    'Mgmt BF Req':                          a.mgmtAppvBusinessFinanceReq        || '',
                    'Mgmt BF Status':                       a.mgmtAppvBusinessFinanceStatus     || '',
                    'Mgmt BF Message':                      a.mgmtAppvBusinessFinanceMessage    || '',
                    'Mgmt BF Date':                         a.mgmtAppvDateBusinessFinance       || '',
                    'Mgmt CEO Req':                         a.mgmtAppvCEOReq                    || '',
                    'Mgmt CEO Status':                      a.mgmtAppvCEOStatus                 || '',
                    'Mgmt CEO Message':                     a.mgmtAppvCEOMessage                || '',
                    'Mgmt CEO Date':                        a.mgmtAppvDateCEO                   || '',
                    'Mgmt COO Req':                         a.mgmtAppvCOOReq                    || '',
                    'Mgmt COO Status':                      a.mgmtAppvCOOStatus                 || '',
                    'Mgmt COO Message':                     a.mgmtAppvCOOMessage                || '',
                    'Mgmt COO Date':                        a.mgmtAppvDateCOO                   || '',
                    'Mgmt CFO Req':                         a.mgmtAppvCFOReq                    || '',
                    'Mgmt CFO Status':                      a.mgmtAppvCFOStatus                 || '',
                    'Mgmt CFO Message':                     a.mgmtAppvCFOMessage                || '',
                    'Mgmt CFO Date':                        a.mgmtAppvDateCFO                   || '',
                };
            });
            // ─── BUILD WORKBOOK ──────────────────────────────────────
            const worksheet = XLSX.utils.json_to_sheet(rows);
            // Auto column width based on header length
            const colWidths = Object.keys(rows[0] || {}).map(key => ({
                wch: Math.max(key.length + 2, 14)
            }));
            worksheet['!cols'] = colWidths;
            // Freeze the first row (headers)
            worksheet['!freeze'] = { xSplit: 0, ySplit: 1 };
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Enterprise CostSheet');
            const today = new Date().toLocaleDateString('en-IN').replace(/\//g, '-');
            XLSX.writeFile(workbook, `EntCostSheetList_${today}.xlsx`);
            console.log('✅ Excel exported successfully');
        } catch (error) {
            console.error('❌ Export failed:', error);
        } finally { 
            setListLoading(false);
        }
    };


    if (error) return <h1>Error: {error.message}</h1>;
    return (
        <>
            <Navbar />
            {/* <h1 className='headerRibbon'>costSheetENT Logs</h1> */}

             <style>
        {`
          /* TR styling */
          .expandable-row {
            transition: background-color 0.3s ease;
          }

          .expandable-row:hover {
            background-color: #f9f9f9;
          }

          /* TD styling */
          .expandable-cell {
            padding: 0;
            margin: 0;
            border: none;
          }

          /* Inner wrapper for animation */
          .cell-wrapper {
            max-height: 30px;
            overflow: hidden;
            transition: max-height 0.4s ease;
            padding: 10px;
          }

          .expandable-row:hover .cell-wrapper {
            max-height: 500px;
          }
        `}
      </style>

            <Container className="pt-3 mb-2">
                <Row className="justify-content-between">
                    <Col md="auto">

                    </Col>
                    <Col md="auto">
                        <h1>Enterprise CostSheet List</h1>
                        {/* <Button variant="success" onClick={openNewForm}>New +</Button> */}
                    </Col>
                    <Col md="auto">
                        {/* <Button variant="success"onClick={exportExcel}>EXPORT</Button> */}
                        <Button variant="success" onClick={fetchAndExport} disabled={listLoading}>{listLoading ? 'Exporting...' : 'Export to Excel'}</Button>
                    </Col>
                </Row>
            </Container>
            <MDBContainer fluid style={{ justifyItems: 'center' }}>
                <div style={styles.tableWrapper}>
                    <MDBTable align='middle' bordered hover small>
                        <MDBTableHead className='table-dark sticky-header'>
                            <tr>
                                {/* <th scope='col' ></th> */}
                                <th scope='col' >Sr No.</th>
                                <th scope='col' >CRM No.</th>
                                <th scope='col' >Customer Name</th>
                                <th scope='col' >Salesperson Name</th>
                                <th scope='col' >Total Revenue</th>
                                <th scope='col' >Total Cost</th>
                                <th scope='col' >Total Other Cost</th>
                                <th scope='col' >Margin</th>
                                <th scope='col' >Margin %</th>
                                <th scope='col' >Vendor terms</th>
                                <th scope='col' >Customer terms</th>
                                <th scope='col' >Actual Cost Amount</th>
                                <th scope='col' >Actual Payment Amount</th>
                                <th scope='col' >Actual Vendor Payment Date</th>
                                <th scope='col' >Actual Revenue Amount</th>
                                <th scope='col' >Actual  Receipt Amount</th>
                                <th scope='col' >Actual Customer Receipt Date</th>
                                <th scope='col' >Gross Margin %</th>
                                <th scope='col' >Gross Margin Improve/ (Drop)%</th>
                                <th scope='col' >Cashflow impacted Days</th>
                                <th scope='col' >Finance Exp/(Income)</th>
                                <th scope='col' >Finance %</th>
                                <th scope='col' >Margin Benefit / Impact</th>
                                <th scope='col' >Cashflow Benefit/ Impact</th>
                                <th scope='col' >Net Benefit/Impact beyond the approval</th>
                                <th scope='col' >Expert Advice on Deal Analysis</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {currentRows.map((row, index) => (
                                <tr key={index} className="expandable-row" >
                                    {/* <th scope='row'></th> */}
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.formSeries}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.crmNumber}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.customerName}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.salesPersonName}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.entCostSheetFinancials.sellingValue}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.entCostSheetFinancials.transferPrices}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>
                                            {
                                                (row.entCostSheetFinancials.contingencyFee || 0) +
                                                (row.entCostSheetFinancials.financeFee || 0) +
                                                (row.entCostSheetFinancials.forexFee || 0) +
                                                (row.entCostSheetFinancials.penalty || 0) +
                                                (row.entCostSheetFinancials.insuranceFee || 0)
                                            }</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.entCostSheetFinancials.margin}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{`${row.entCostSheetFinancials.marginPercentage}%`}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.vendorPaymentTerms}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.customerPaymentTerms}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.expectedDaysOfDeliveryOfProductFromVendor}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.vendorCreditPeriodForThisDealInDays}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.vendorBillingCycle}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.sellingValueTotal}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.purchaseValueTotal}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.marginYearTotal}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.marginPercentage}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.expectedPoDate}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.expertAdviceCashflow}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.expertAdviceMargin}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.confirmedPODate}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.actualMarginCrmWon}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.actualMarginCrmWon}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.actualMarginCrmWon}</p> */}
                                    </td>
                                    <td className="expandable-cell">
                                        <p>NA</p>
                                        {/* <p className='text-muted mb-0 cell-wrapper'>{row.actualMarginCrmWon}</p> */}
                                    </td>
                                </tr>
                            ))}
                        </MDBTableBody>
                    </MDBTable>
                </div>

                {/* Pagination Controls */}
                {/* <div style={styles.pagination}>
                    <button
                        style={styles.pageButton}
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        Previous
                    </button>
                    {[...Array(totalPages).keys()].map((number) => (
                        <button
                            key={number}
                            style={{ ...styles.pageButton, ...(number + 1 === currentPage ? styles.activePageButton : {}) }}
                            onClick={() => handlePageChange(number + 1)}
                        >
                            {number + 1}
                        </button>
                    ))}
                    <button
                        style={styles.pageButton}
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        Next
                    </button>
                </div> */}

                <div style={styles.pagination}>
            <button
                style={styles.pageButton}
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
            >
                Previous
            </button>

            {startPage > 1 && (
                <>
                    <button style={styles.pageButton} onClick={() => handlePageChange(1)}>1</button>
                    <span style={styles.ellipsis}>...</span>
                </>
            )}

            {[...Array(endPage - startPage + 1).keys()].map((index) => {
                const pageNum = startPage + index;
                return (
                    <button
                        key={pageNum}
                        style={{
                            ...styles.pageButton,
                            ...(pageNum === currentPage ? styles.activePageButton : {}),
                        }}
                        onClick={() => handlePageChange(pageNum)}
                    >
                        {pageNum}
                    </button>
                );
            })}

            {endPage < totalPages && (
                <>
                    <span style={styles.ellipsis}>...</span>
                    <button style={styles.pageButton} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                </>
            )}

            <button
                style={styles.pageButton}
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
            >
                Next
            </button>
        </div>

            </MDBContainer>
        </>
    );
};

// Inline CSS for the component
// const styles = {
//     tableWrapper: {
//         maxWidth: '90%',
//         overflowX: 'auto', // Enable horizontal scrolling
//         overflowY: 'auto', // Enable vertical scrolling
//         maxHeight: '590px', // Adjust the height to fit your needs
//         marginBottom: '10px',
//     },
//     // stickyHeaderStyle: {
//     //     position: 'sticky',
//     //     top: 0,
//     //     background: 'white',
//     //     zIndex: 1,
//     // },
//     pagination: {
//         display: 'flex',
//         justifyContent: 'center',
//         gap: '5px',
//     },
//     pageButton: {
//         backgroundColor: '#007bff',
//         color: 'white',
//         border: 'none',
//         borderRadius: '4px',
//         padding: '5px 10px',
//         cursor: 'pointer',
//         outline: 'none',
//     },
//     activePageButton: {
//         backgroundColor: '#0056b3',
//     },
// };

const styles = {
        tableWrapper: {
            maxWidth: '95%',
            overflowX: 'auto', // Enable horizontal scrolling
            overflowY: 'auto', // Enable vertical scrolling
            maxHeight: '450px', // Adjust the height to fit your needs
            marginBottom: '10px',
        },
        pagination: {
            display: 'flex',
            justifyContent: 'center',
            gap: '5px',
            flexWrap: 'wrap',
            marginTop: '1rem',
        },
        pageButton: {
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            cursor: 'pointer',
            outline: 'none',
        },
        activePageButton: {
            backgroundColor: '#0056b3',
        },
        ellipsis: {
            padding: '5px 10px',
            color: '#555',
        },
    };

// CSS styles
const stickyHeaderStyles = `
.sticky-header th {
    position: sticky;
    top: 0;
    z-index: 10; // Ensures the header is on top
    background-color: #343a40; // Match the table header color
    color: white; // Text color for header
}
`;

// Add the sticky header styles to the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = stickyHeaderStyles;
document.head.appendChild(styleSheet);

export default CostSheetEntList
